export default "__VITE_ASSET__80f06188__"